import { Pipe, PipeTransform } from '@angular/core';
import { Property } from '@ui/shared/model';
import { canViewPropertyProspects } from '../../utils/properties';

@Pipe({
  name: 'canViewProspectsPipe'
})
export class CanViewProspectsPipePipe implements PipeTransform {
  transform(property: Property): boolean {
    return canViewPropertyProspects(property);
  }
}
